import './content-slider.component.pug'
import './content-slider.component.scss'

import { Swiper, Pagination } from 'swiper'
Swiper.use(Pagination)

document.querySelectorAll('.content-slider').forEach((root) => {
  const swiperElement = root.querySelector(
    '.content-slider__content.swiper-container'
  )
  new Swiper(swiperElement, {
    slidesPerView: 1,
    autoHeight: true,
    pagination: {
      el: swiperElement.querySelector('.swiper-pagination'),
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      1024: {
        autoHeight: false
      }
    }
  })
})
